// SHAPES
export const SQUARE_SHAPE = 'square';
export const ROUNDED_SHAPE = 'rounded';
export const CIRCLE_SHAPE = 'circle';

export const SHAPES = [SQUARE_SHAPE, ROUNDED_SHAPE, CIRCLE_SHAPE];
